import { gql } from '@apollo/client';

const GET_CURRENT_COMPANY_MEMBER = gql`
  query CompanyMembers($userId: ID!, $companyId: ID!) {
    companyMembers(userId: $userId, companyId: $companyId) {
      id
      role
    }
  }
`;

export default GET_CURRENT_COMPANY_MEMBER;
